import { QUERY_KEYS } from "constants/query-keys";
import { useQuery } from "@tanstack/react-query";
import apiClient from "api/api-client";
import { StaticContent } from "types/static-content";

export const useGetInformationalContentArticle = (id: number) => {
  return useQuery({
    queryKey: [QUERY_KEYS.informationalContentArticleGet, id],
    queryFn: async () => {
      const response = await apiClient.get<StaticContent>(`/public/informational-content/articles/${id}`);
      return response.data;
    },
    enabled: !!id,
  });
};
